import { OpenLink } from 'components/search/expedia/enums';
import { OpenLinkState } from 'components/search/expedia/interfaces';

const initialOpenLinkState: OpenLinkState = {
  openLink: OpenLink.SAME_WINDOW,
};

export { initialOpenLinkState };
